module.exports = __webpack_public_path__ + "static/image-03-a@2x-9c7a2e76a757bb8a69d8076e90af9055.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/case-studies/hudl/image-03-a@2x.jpg
// module id = 380
// module chunks = 3627797113349 20562973939449 33019919093843